<template>
    <v-container class="center-content">
      <center>
        <div style="width: 100%;">
          <h1>Pricing Plans</h1>
          <p>Find the perfect plan to power your investigations.</p>
        </div>
      </center>
  
      <div class="saut-1-pc"></div>
      <div class="switch-wrapper">
      <v-switch
        v-model="model"
        :label="` year`"
        hide-details
        inset
      ></v-switch>
    </div>
    <div class="saut-2-pc"></div>

      <br>
      <v-row align="center" justify="center" id="pds">
      <v-col
        v-for="(product, index) in filteredProducts"
        :key="index"
        cols="12"
        lg="3"
        sm="6"
        md="6"
        class="pa-2"
      >
<v-card
  :class="{ 'best-product': product.best_product }"
  class="mx-auto pd"
  max-width="100%"
  width="330px"
  hover
>
  <v-card-item>
    <div>
      <div class="text-overline mb-1">{{ product.name }}</div>
      <h2 class="text-h4" v-if="product.duree == 'mo'">
        {{ product.delivery_search_quantity }} search
        <span style="font-size: 15px;"> / Month</span>
      </h2>
      <h2 class="text-h4" v-else>
        {{ product.delivery_search_quantity / 12 }} search
        <span style="font-size: 15px;"> / Month</span>
      </h2>
      <v-spacer></v-spacer>
      <div class="text-h6 mb-1" v-if="product.duree == 'y'">
        <div v-if="product.price == 58.33">
          <del>70€<span style="font-size: 15px;"> / Month</span></del>&nbsp;&nbsp;
        </div>
        <div v-else>
          <del style="font-size: 15px;">{{ (product.price * 12) / 10 }}€<span > / Month</span></del>&nbsp;&nbsp;
        </div>
        {{ product.price }}€<span style="font-size: 15px;"> / Month</span>
      </div>
      <div class="text-h6 mb-1" v-else>
        {{ product.price }}€<span style="font-size: 15px;"> / Month</span>
      </div>
      <ul class="features-list">
        <li v-for="(feature, i) in parseFeatures(product.description)" :key="i">
          <v-icon color="blue" class="me-2">mdi-check-circle</v-icon>
          {{ feature }}
        </li>
      </ul>
    </div>
  </v-card-item>

  <v-card-actions v-if="!hasSubscription">
    <v-btn
      class="btbtn"
      block
      color="blue"
      variant="tonal"
      v-if="isAuthentified"
      @click="handleCheckout(product.price_id, product.product_type)"
    >
      Buy
    </v-btn>
    <v-btn
      class="btbtn"
      block
      color="blue"
      variant="tonal"
      v-else
      :to="{ path: '/login' }"
    >
      Buy
    </v-btn>
  </v-card-actions>
  <v-card-actions v-else>
    <v-btn :to="{ path: '/mysubscription' }">
      You must unsubscribe to buy
    </v-btn>
  </v-card-actions>
</v-card>

      </v-col>
    </v-row>
    </v-container>
    <div style="height: 20vh;"></div>
    <div style="height: 20vh;"></div>
    <div style="height: 20vh;"></div>
    <div style="height: 40vh;" v-if="tpetit"></div>
  </template>
  
  <style setup> 

    @media only screen and (min-width: 600px) {
      .saut-1-pc{
        height: 2vh;
      }

      .saut-2-pc{
        height: 2vh;
      }

      h1{
            font-size: 65px;
            color: white;
            font-family: Inter, sans-serif;
        }

    }

    
    h1{
        font-size: 35px;
        color: white;
        font-family: Inter, sans-serif;
    }

    .v-card-actions {
      bottom: 0; /* Force les actions à se positionner en bas */
    }

    .pd{
      text-align: left;
      background-color: rgba(92, 92, 92, 0.103);
      height: 100%;        
    }


    .pd:hover{
        text-align: left;
        transition: 0.5s;
        box-shadow: 0px 0px 10px #0776f4;
    }

    .switch-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0; /* Espace autour du switch */
    }


    p{
        font-size: 20px;
    }
    
  
    #tabs {
        margin-bottom: 15px;
    }
  

    .active-tab {
        color: #0782f4;
        font-weight: bold;
        border-bottom: 2px solid #0766f4;
    }

    v-btn{
      width: 100%;
    }

  </style>
  

  <script>
  import { mapGetters } from 'vuex';
  
  export default {
    data() {
      return {
        tpetit: false,
        petit: false,
        model: false,
        isAuthentified: localStorage.getItem('Authorization') !== null,
        hasSubscription: JSON.parse(localStorage.getItem('userdata')) ? JSON.parse(localStorage.getItem('userdata')).hasSubscription : false,
        products: [],
      };
    },
    created() {
      this.tpetit = window.innerWidth < 1289;
      this.petit = window.innerWidth < 1880;
      this.getProducts();
    },
    computed: {
      ...mapGetters(['backend']),
      filteredProducts() {
      return this.products.filter((product) =>
        this.model ? product.duree === "y" : product.duree === "mo"
      );
    },

    },
    methods: {

      parseFeatures(description) {
        return description.replace(/☑️/g, '').replace(/❌/g, '').split("\n").filter((line) => line.trim() !== "");
      },

      async getProducts() {
        try {
          const response = await this.$axios.get(`${this.backend}/api/product/products`);
          this.products = response.data;
        } catch (error) {
          console.error('Error fetching products:', error);
        }
      },
      async handleCheckout(price_id, product_type) {
        try {
          const token = localStorage.getItem('Authorization');
          const response = await this.$axios.post(
            `${this.backend}/api/payment/create-checkout-session`,
            { price_id, product_type },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          window.location.href = response.data;
        } catch (error) {
          console.error('Error during checkout:', error);
        }
      },
    },
  };
  </script>
  